import { render } from "./ProyectosSection.vue?vue&type=template&id=669f7ad8&scoped=true"
import script from "./ProyectosSection.vue?vue&type=script&lang=js"
export * from "./ProyectosSection.vue?vue&type=script&lang=js"

import "./ProyectosSection.vue?vue&type=style&index=0&id=669f7ad8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669f7ad8"]])

export default __exports__